var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup49(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#233155;stroke-width:2px;}.b{fill:#233155;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-163 -211)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(163 211)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 22,
    height: 24,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 1,
    y: 1,
    width: 20,
    height: 22,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2,
    height: 2,
    transform: "translate(167 222) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2,
    height: 2,
    transform: "translate(167 216) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2,
    height: 2,
    transform: "translate(167 228) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3,
    height: 2,
    transform: "translate(176 226) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(171 219)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4,
    cy: 4,
    r: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup49);
export default __webpack_public_path__ + "static/media/Group 49.68eae0adf30c7b5abb05afbc1232fc5c.svg";
export { ForwardRef as ReactComponent };